<i18n
  src="@/locales/components/views/packing_house/quality_control/process/harvested_batch_info.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/harvested_batch.yml" lang="yaml"></i18n>
<template>
  <h1 class="page-title">
    <i class="fa-solid fa-crate-apple"></i
    ><span class="space-icon"></span>
    {{ show_code ? harvested_batch?.batch_code : "Lote" }}
  </h1>
  <div class="my-8">
    <div class="panel">
      <div class="panel-body">
        <div class="divide-y divide-slate-200">
          <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.harvested_batch.week") }}
              </dt>
              <dd class="content-data">
                {{ harvested_batch.week }}
              </dd>
            </div>

            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.harvested_batch.registered_at") }}
              </dt>
              <dd class="content-data">
                {{ dateFormatter(harvested_batch.registered_at) }}
              </dd>
            </div>

            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.harvested_batch.producer") }}
              </dt>
              <dd class="content-data">
                {{ producerLabel(harvested_batch) }}
              </dd>
            </div>

            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.harvested_batch.total_weight") }}
              </dt>
              <dd class="content-data">
                {{ numberWithPrecision(harvested_batch.total_weight) }}
              </dd>
            </div>

            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.harvested_batch.discarded_weight") }}
              </dt>
              <dd class="content-data">
                {{ numberWithPrecision(harvested_batch.discarded_weight) }}
              </dd>
            </div>

            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.harvested_batch.ok_weight") }}
              </dt>
              <dd class="content-data">
                {{ numberWithPrecision(harvested_batch.ok_weight) }}
              </dd>
            </div>

            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.harvested_batch.crop_type") }}
              </dt>
              <dd class="content-data">
                {{ harvested_batch.crop_type?.name }}
              </dd>
            </div>

            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.harvested_batch.crop_variety") }}
              </dt>
              <dd class="content-data">
                {{ harvested_batch.crop_variety?.name }}
              </dd>
            </div>

            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.harvested_batch.agro_exporter") }}
              </dt>
              <dd class="content-data">
                {{ harvested_batch.agro_exporter?.name }}
              </dd>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HarvestedBatchInfo",
  data: () => ({
    open: false
  }),
  props: {
    harvested_batch: {
      type: Object,
      required: true
    },
    show_code: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    producerLabel: function (harvested_batch) {
      if (harvested_batch.producer && harvested_batch.organization) {
        return `${harvested_batch.producer.name} (${harvested_batch.organization.name})`;
      } else if (harvested_batch.organization) {
        return harvested_batch.organization.name;
      } else if (harvested_batch.producer) {
        return harvested_batch.producer.name;
      }
    }
  }
};
</script>
